<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                     <v-btn dark icon title="Back to employee list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="payroll" pageId="payroll-adustments-create" color="white"></help-link>
                    <v-btn v-if="hasAddRights" fab dark small color="primary" title="Add Payroll Adjustments" @click="showAdd">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                </v-toolbar>
            </v-card>
            <v-card v-if="!loading" class="elavation-1 mt-5"> 
                <v-toolbar flat height="45px">
                    <div :class="isMobile?'wp-50 mb-10':'wp-30 mb-10'">
                        <v-text-field v-model="search" append-icon="search" label="Search name or type" single-line hide-details></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                    <span class="ml-10"><b>{{getCoverageDesc}}</b></span>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="manual_adjustments_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                    :hide-headers="isMobile"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">

                        <!-- mobile view -->
                        <tr v-if="isMobile">
                            <td :colspan="headers.length" class="pa-1">
                                <v-card class="elevation-1" @click="viewDetails(props.item)">
                                    <v-toolbar flat height="42">
                                        <v-chip class="user-chip-container">
                                            <v-avatar>
                                                <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                            </v-avatar>
                                            {{props.item.firstName}} {{props.item.lastName}}
                                        </v-chip>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-layout row wrap align-center class="section-layout">
                                        <v-flex xs12 class="text-xs-left mt-5 mb-2">
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Type</div>
                                                    <div>{{ props.item.manualAdjustmentName }}</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Journal</div>
                                                    <div v-if="props.item.transType==1">Credit to Payroll</div>
                                                    <div v-else>Debit to Payroll</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Tax</div>
                                                    <div v-if="props.item.transType==1">
                                                        <div v-if="props.item.addToTaxableIncome">Taxable</div>
                                                        <div v-else>Non-taxable</div>
                                                    </div>
                                                    <div v-else>
                                                        <div v-if="props.item.deductFromTaxableIncome">Deductible</div>
                                                        <div v-else>Not deductible</div>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Amount</div>
                                                    <div>{{numFormat.formatNumber(props.item.amount)}}</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Status</div>
                                                    <div :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Created On</div>
                                                    <div>{{ props.item.createdOn | moment('MMM DD, YYYY')}}</div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row v-if="props.item.remarks">
                                                <v-flex xs12>
                                                    <div class="caption grey--text text--darken-1">Note</div>
                                                    <div>{{props.item.remarks}}</div>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </td>
                        </tr>

                        <!-- desktop view -->
                        <tr v-else @click="viewDetails(props.item)" class="clickable" title="Click to view/edit">
                            <td>
                                <v-chip class="user-chip-container">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.firstName}} {{props.item.lastName}}
                                </v-chip>
                            </td>
                            <td>
                                {{ props.item.manualAdjustmentName }}
                            </td>
                            <td>
                                <span v-if="props.item.transType==1">Credit to Payroll</span>
                                <span v-else>Debit to Payroll</span>
                            </td>
                            <td>
                                <span v-if="props.item.transType==1">
                                    <span v-if="props.item.addToTaxableIncome">Taxable</span>
                                    <span v-else>Non-taxable</span>
                                </span>
                                <span v-else>
                                    <span v-if="props.item.deductFromTaxableIncome">Deductible</span>
                                    <span v-else>Not deductible</span>
                                </span>
                            </td>
                            <td>{{numFormat.formatNumber(props.item.amount)}}</td>
                            <td>
                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                            <td>{{ props.item.createdOn | moment('MMM DD, YYYY')}}</td>
                            <td>{{props.item.remarks}}</td>
                        </tr>
                    </template>
                </v-data-table> 
             </v-card>
        </v-flex>
        <v-dialog v-model="dialogManualAdjustments" width="700" persistent>   
            <adjustments ref="adjustmentsRef" :dialogManualAdjustments.sync="dialogManualAdjustments" @send="createItemHandler"></adjustments>
        </v-dialog>
    </v-layout> 
</template>

<script>

import manualAdjustmentsApi from '@/api/manualadjustments'
import commonfn from '@/common/functions'
import numFormat from '@/common/num_format'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import { hasAddRights } from '@/helpers/access-permissions'

export default {     
    name: 'Adjustments',
    metaInfo: {
        title: 'Adjustments',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, create Manual Adjustments' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'adjustments': () => import('@/components/Payroll/ManualAdjustments'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            numFormat,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            search: userPrefs.getSearchKeyword(routeName),
            error: false,
            errorMessage: '',
            loading: false,
            headers: [
                {text:'Employee', align:'left', value:'lastName', width: '10%', sortable:true},
                {text:'Type', align:'left', value:'manualAdjustmentName',  width: '10%', sortable:true},
                {text:'Journal', align:'left', value:'transType',  width: '10%', sortable:true},
                {text:'Tax', align:'left', value:'',  width: '10%', sortable:false},
                {text:'Amount', align:'left', value:'amount',  width:'10%', sortable:true},
                {text:'Status', align:'left', value:'status',  width:'10%', sortable:true},
                {text:'Created On', align:'left', value:'createdOn',  width:'10%', sortable:true},
                {text:'Note', align:'left', value:'',  width:'15%', sortable:false},
            ],
            dialogManualAdjustments: false,
            cutoff_period: null,
            serverDate: null,
            company_details: null,
            manual_adjustments: []
        }
    },
    methods: {
        createItemHandler(data) {
             this.$router.push(`/payroll/adjustments/details/${data}`)
        },
        viewDetails(data) {
            this.$router.push(`/payroll/adjustments/details/${data.manualAdjustmentId}`)
        },
        async showAdd() {
            this.$refs.adjustmentsRef.setAdd(this.selectedCutoffId)
            this.dialogManualAdjustments = true
        },
        async getManualAdjustments(){
            try{
                this.loading = true
                const response = await manualAdjustmentsApi.getByCutoff(this.selectedCutoffId)
                if (response && response.status == 200) {
                    this.manual_adjustments = response.data.items
                    this.cutoff_period = response.data.cutoffItem
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Payroll Adjustments'
        })

        this.getManualAdjustments()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            userPrefs.updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        manual_adjustments_filtered() {
            var temp = this.manual_adjustments
            
            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    const searchLower = this.search.toLowerCase()
                    const firstNameMatch = item.firstName.toLowerCase().includes(searchLower)
                    const lastNameMatch = item.lastName.toLowerCase().includes(searchLower)
                    const typeMatch = item.manualAdjustmentName.toLowerCase().includes(searchLower)

                    return firstNameMatch || lastNameMatch || typeMatch
                })
            }
            return temp
        },
        hasAddRights() {
            return hasAddRights(this.$router.currentRoute.path)
        },
        selectedCutoffId() {
            return this.$route.params.cutOffId
        },
        getCoverageDesc() {
            if (this.loading) return;
             
            const start = this.$moment(this.cutoff_period.cutoffStart);
            const end = this.$moment(this.cutoff_period.cutoffEnd);

            const sameYear = start.year() === end.year();
            const sameMonth = start.month() === end.month() && sameYear;

            if (sameMonth) {
                // Aug 1–15, 2025
                return `${start.format('MMM D')} - ${end.format('D, YYYY')}`;
            }

            if (sameYear) {
                // Aug 25 – Sep 10, 2025
                return `${start.format('MMM D')} - ${end.format('MMM D, YYYY')}`;
            }

            // Dec 26, 2025 – Jan 10, 2026
            return `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`
        },
        isMobile() {
            return window.innerWidth < 600
        },
    }
}
</script>
<style scoped>
.section-layout {
    padding:0px 23px 0px 23px;
}
</style>